import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Satoshi, sans-serif',
  },
});

export default theme;